import { ErrorStateType, ISetPassword } from '@models';
import i18n from '@configs/i18n';

import {
  SET_PASSWORD_FAILED,
  SETTING_PASSWORD,
  PASSWORD_SET,
  ISetPasswordFailedAction,
  ISettingPasswordAction,
  SetPasswordActionTypes,
} from '@store/types';
import { didLogIn } from '@store/actions';

import { IUserDto } from '@services/auth';
import { setPassword as setPasswordRequest } from '@services/user';

import { RequestError, HttpStatusCode } from '@utils';

export const setPassword = (setPasswordParams: ISetPassword): any => {
  return (dispatch: (action: SetPasswordActionTypes) => void) => {
    dispatch(settingPassword());
    return setPasswordRequest(setPasswordParams)
      .then((user: IUserDto) => {
        dispatch({ type: PASSWORD_SET });
        didLogIn(user, dispatch);
      })
      .catch((error: RequestError) => {
        let message = error.message;
        if (error.status === HttpStatusCode.UNPROCESSABLE_ENTITY) {
          switch (error.code) {
            case ErrorStateType.InvalidPasswordResetToken:
              message = i18n.t('setPassword_error_invalidPasswordResetToken');
              break;
            case ErrorStateType.TokenTimedOut:
              message = i18n.t('setPassword_error_expiredPasswordResetToken');
              break;
            default:
              message = i18n.t('common_unknownError');
              break;
          }
        }
        dispatch(setPasswordFailed(message));
      });
  };
};

export const setPasswordFailed = (
  error?: string
): ISetPasswordFailedAction => ({
  type: SET_PASSWORD_FAILED,
  payload: error,
});

export const settingPassword = (): ISettingPasswordAction => ({
  type: SETTING_PASSWORD,
});
